<app-contentful-renderer [model]="model.subject"></app-contentful-renderer>
